{
  "recaptcha_site_key": "6LeUpqwcAAAAAIbPGZBewpl-dRr-Ca7x86v_8Mc0",
  "firebase_api_key": "AIzaSyCiap1CNmRfZ2eNXKMmjEmoYLCc197cUiI",
  "release": "5558cd4c21020d5897611d72db9ba8db90454447"
}
